import { memo } from "react";
import { Div, PageHeader, useTheme } from "react-better-html";

import { useI18n } from "../../../utils/i18n";

import GeneralSection from "./GeneralSection";
import AppearanceSection from "./AppearanceSection";
import NotificationsSection from "./NotificationsSection";
import OrganizationSection from "./OrganizationSection";

function Settings() {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <>
         <PageHeader title={t((l) => l.pages.settings.title)} titleAs="h2" marginBottom={theme.styles.space} />

         <Div.column gap={theme.styles.space}>
            <GeneralSection />
            <AppearanceSection />
            <NotificationsSection />
            <OrganizationSection />
         </Div.column>
      </>
   );
}

export default memo(Settings);
